/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  ToFaResponse,
  VerifyCreateRequest,
  VerifyCreateResponse,
} from '@/core/interfaces/common'
import {
  CalculateRequest,
  CalculateResponse,
  ChangeEmailCodeRequest,
  ChangeEmailRequest,
  ChangeEmailResponse,
  ChangeEmailStatusResponse,
  CurrencyCourse,
  CurrencyDayCourseResponse,
  ICreateExchangeRequest,
  ICreateExchangeResponse,
  IExchangeResponse,
} from '@/core/interfaces/exchange'
import { AxiosResponse } from 'axios'

import { http } from '@/utils/http'
import { transformStatsToArray } from '@/utils/transformStatsToArray'

class AppService {
  async getVerifyUser(
    data: VerifyCreateRequest,
  ): Promise<VerifyCreateResponse> {
    const res = await http.post<
      VerifyCreateRequest,
      AxiosResponse<VerifyCreateResponse>
    >(`/verify/create`, data)
    return res.data
  }

  async getSecurityInfo(): Promise<ToFaResponse> {
    const res = await http.post(`/profile/2fa`)
    return res.data
  }

  async getPreviewExchange(): Promise<any> {
    const res = await http.get(`/exchange`)
    return res.data
  }

  async ICreateExchangeRequest(
    data: ICreateExchangeRequest,
  ): Promise<ICreateExchangeResponse> {
    const res = await http.post<
      ICreateExchangeRequest,
      AxiosResponse<ICreateExchangeResponse>
    >(`/exchange/create`, data)
    return res.data
  }

  async calculation(data: CalculateRequest): Promise<CalculateResponse> {
    const res = await http.post<
      CalculateRequest,
      AxiosResponse<CalculateResponse>
    >(`/calculation`, data)
    return res.data
  }

  async getCourse(): Promise<IExchangeResponse> {
    const res = await http.get(`/course`)
    return res.data
  }

  async getDayCourse(): Promise<CurrencyCourse[]> {
    const res = await http.get<CurrencyDayCourseResponse>(`/day_course`)

    return transformStatsToArray(res.data)
  }

  async changeEmail(data: ChangeEmailRequest): Promise<ChangeEmailResponse> {
    const res = await http.post<
      ChangeEmailRequest,
      AxiosResponse<ChangeEmailResponse>
    >(`/profile/change/email`, data)
    return res.data
  }

  async changeEmailCode(data: ChangeEmailCodeRequest): Promise<any> {
    const res = await http.post(`/profile/change/email/code`, data)
    return res.data
  }

  async changeEmailResent(): Promise<any> {
    const res = await http.post(`/profile/change/email/resent`)
    return res.data
  }

  async changeEmailStatus(): Promise<ChangeEmailStatusResponse> {
    const res = await http.get(`/profile/change/email`)
    return res.data
  }

  async deleteChangeEmail(): Promise<any> {
    const res = await http.post(`/profile/change/email/cancel`)
    return res.data
  }
}

export default new AppService()
